import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "auth-signup__step signup-step-supporter" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "el-form__cta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_ElCheckbox = _resolveComponent("ElCheckbox")!
  const _component_ElCheckboxGroup = _resolveComponent("ElCheckboxGroup")!
  const _component_PxInputPlaces = _resolveComponent("PxInputPlaces")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PxPanel, { class: "px-panel--compact" }, {
      header: _withCtx(() => [
        _createElementVNode("h2", {
          class: "px-panel__title",
          innerHTML: _ctx.$t('supporters.signup.form.supporterDetails')
        }, null, 8, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ElForm, {
          ref: "signupForm",
          model: _ctx.data,
          rules: _ctx.rules,
          class: "auth-signup__form",
          onValidate: _ctx.updateSubmitState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.supporterName'),
              prop: "supporter.name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInput, {
                  modelValue: _ctx.data.supporter.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.supporter.name) = $event)),
                  placeholder: _ctx.$t('supporters.signup.form.fields.supporterName')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.supporterType'),
              prop: "supporter.types"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElCheckboxGroup, {
                  modelValue: _ctx.selectedTypes,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTypes) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTypes, (type, key) => {
                      return (_openBlock(), _createBlock(_component_ElCheckbox, {
                        key: key,
                        label: type.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.name) + " ", 1),
                          (type.label)
                            ? (_openBlock(), _createBlock(_component_ElTooltip, {
                                key: 0,
                                placement: "top",
                                "popper-class": "auth-signup__tooltip el-abaca-tooltip"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: type.label
                                  }, null, 8, _hoisted_3)
                                ]),
                                default: _withCtx(() => [
                                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "icon icon-question" }, null, -1))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128)),
                    _createVNode(_component_ElCheckbox, { onChange: _ctx.otherTypeChangeHandler }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("supporters.signup.form.fields.otherSupporterType")), 1)
                      ]),
                      _: 1
                    }, 8, ["onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.hasOtherType)
                  ? (_openBlock(), _createBlock(_component_ElInput, {
                      key: 0,
                      modelValue: _ctx.data.supporter.otherType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.supporter.otherType) = $event)),
                      placeholder: 
              _ctx.$t('supporters.signup.form.placeholders.supporterType')
            ,
                      class: "other-type-input"
                    }, null, 8, ["modelValue", "placeholder"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.location'),
              prop: "supporter.location"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PxInputPlaces, {
                  id: "supporterLocation",
                  modelValue: _ctx.data.supporter.location,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.supporter.location) = $event)),
                  placeholder: _ctx.$t('supporters.signup.form.fields.location'),
                  "use-geolocation": true
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ElFormItem, {
              label: _ctx.$t('supporters.signup.form.fields.website'),
              prop: "supporter.website"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInput, {
                  modelValue: _ctx.data.supporter.website,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.supporter.website) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: 
              _ctx.$t('authentication.signup.form.fields.websitePlaceholder')
            
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_PxIcon, {
                      size: 24,
                      name: "website"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PxButton, {
                disabled: _ctx.stepDisabled,
                size: "medium",
                type: "primary",
                onClick: _ctx.goToNextStep
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("supporters.signup.form.stepButton")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "onValidate"])
      ]),
      _: 1
    })
  ]))
}